export const CustomerUserListColumnsModel = [
  {
    label: 'First Name',
    type: 'string',
    property: 'firstName',
    cellClass: 'display-column'
  },
  {
    label: 'Last Name',
    type: 'string',
    property: 'lastName',
    cellClass: 'display-column'
  },
  {
    label: 'Email',
    type: 'string',
    property: 'email',
    cellClass: 'display-column'
  },
  {
    label: 'Status',
    type: 'string',
    property: 'status',
    cellClass: 'display-column'
  },
  {
    label: 'Reset Password',
    type: 'string',
    property: 'resetPassword',
    cellClass: 'display-column'
  }
];
